import Navbar from './components/Navbar';
import Hero from './components/Hero';
import BusinessIntro from './components/BusinessIntro';
import TatesapoSection from './components/TatesapoSection';
import OrganizingSection from './components/OrganizingSection';
import CompanySection from './components/CompanySection';
import MVVSection from './components/MVVSection';
import Footer from './components/Footer';
import SEOSchema from '../../components/feature/SEOSchema';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: '合同会社べごま',
      url: siteUrl,
      foundingDate: '2023-01-17',
      description:
        '賃貸併用住宅の建築コンサルティング「建てサポ」と、看護師よる子育て・介護世帯向け整理収納アドバイザーサービスを提供する会社です。',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'サービス一覧',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '建てサポ',
              description:
                '賃貸併用住宅の建築コンサルティングサービス。建築計画から住まいづくりまで専門家がサポートします。',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '整理収納アドバイザーサービス',
              description:
                '看護師よる子育て・介護世帯を中心に、日々の暮らしの整理収納を専門家がアドバイスします。',
            },
          },
        ],
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: '合同会社べごま',
      publisher: {
        '@id': `${siteUrl}/#organization`,
      },
      inLanguage: 'ja',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/`,
      url: `${siteUrl}/`,
      name: '合同会社べごま｜建てサポ・整理収納アドバイザー｜住まいと暮らしをトータルサポート',
      description:
        '賃貸併用住宅の建築コンサルティング「建てサポ」と、看護師よる子育て・介護世帯向け整理収納アドバイザーサービス。住まいの建築計画から日々の暮らしの整理まで、専門家がトータルでサポートします。',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'ja',
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <SEOSchema schema={homeSchema} id="home-schema" />
      <Navbar />
      <Hero />
      <BusinessIntro />
      <TatesapoSection />
      <OrganizingSection />
      <CompanySection />
      <MVVSection />
      <Footer />
    </main>
  );
}
